import { useSetRouterValue } from 'weblite-router'

export const NATIVE_COLORS_VALUE_NAME = 'native-colors'

export interface NativeColors {
  statusBar?: string
  bottomSafeArea?: string
}

export function useSetNativeColors(
  valueGetter: () => NativeColors,
  deps: any[],
  isActive = true,
) {
  useSetRouterValue(NATIVE_COLORS_VALUE_NAME, valueGetter, deps, isActive)
}
